import http from 'core/http-common'
import {
  ICoiffeurFilteredReq,
  ICoiffeurSalonFilteredReq,
  ICoiffeurSalonSpecsFilteredReq,
  ICoiffeurSaloonSpecsFilteredList,
  ICoiffeurService,
  ICoiffeurSubServiceList,
  IFilteredCoiffeurList,
  IFilteredCoiffeurSalonList,
  IGetCoiffeurTimeTableList,
  IGetCoiffeurTimeTableReq,
  ISaveCoiffeurReservation,
} from 'types/CoiffeurType'

class CoiffeurService {
  getCoiffeurSalonLocations() {
    return http.get<any>(`CoiffeurService/GetLocationList`)
  }

  getFilteredCoiffeurSalonList(data: ICoiffeurSalonFilteredReq) {
    return http.post<IFilteredCoiffeurSalonList[]>(`CoiffeurSaloon/GetFilteredList`, data)
  }

  getCoiffeurSaloonSpecs(data: ICoiffeurSalonSpecsFilteredReq) {
    return http.post<ICoiffeurSaloonSpecsFilteredList[]>('CoiffeurSaloonSpec/GetFilteredList', data)
  }

  getCoiffeurSubServices(mainServiceId: number) {
    return http.get<ICoiffeurSubServiceList[]>(
      `CoiffeurSubService/GetAllByMainServiceId?mainServiceId=${mainServiceId}`
    )
  }

  getFilteredCoiffeurList(data: ICoiffeurFilteredReq) {
    return http.post<IFilteredCoiffeurList[]>(`Coiffeur/GetFilteredList`, data)
  }

  getCoiffeurPhoto(coiffeurId: number) {
    return http.get(`Coiffeur/GetCoiffeurPhotoBase64String?coiffeurId=0`)
  }

  getCoiffeurServiceByLocalId(locationId: number) {
    return http.get<ICoiffeurService>(`CoiffeurService/GetByLocationId?locationId=${locationId}`)
  }

  getCoiffeurReservationTableList(data: IGetCoiffeurTimeTableReq) {
    return http.post<IGetCoiffeurTimeTableList[]>(`CoiffeurReservation/GetCoiffeurTimeTableList`, data)
  }

  saveCoiffeurReservation(data: ISaveCoiffeurReservation) {
    return http.post(`CoiffeurReservation/SaveCoiffeurReservation`, data)
  }

  /* Favorite */
  addCoiffeurFavorite(coiffeurId: number) {
    return http.get(`FavoriteCoiffeur/Save?coiffeurId=${coiffeurId}`)
  }
  removeCoiffeurFavorite(coiffeurId: number) {
    return http.get(`FavoriteCoiffeur/Delete?coiffeurId=${coiffeurId}`)
  }
}

export default new CoiffeurService()
